/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RECOMMEND_URL = exports.RECOMMEND_URL = 'https://shenzekun-qmusic-api.now.sh/';
var TOPLIST_URL = exports.TOPLIST_URL = 'https://shenzekun-qmusic-api.now.sh/top';
var SEARCH_URL = exports.SEARCH_URL = 'https://shenzekun-qmusic-api.now.sh/search';
var LYRICS_URL = exports.LYRICS_URL = 'https://shenzekun-qmusic-api.now.sh/lyrics';
var HOTKEYS_URL = exports.HOTKEYS_URL = 'https://shenzekun-qmusic-api.now.sh/hotkey';

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.lazyload = lazyload;
function lazyload() {
    var imgs = Array.from(document.querySelectorAll('.lazyload'));
    //判断浏览器是否有IntersectionObserver
    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (changes) {
            changes.forEach(function (change) {
                if (change.intersectionRatio > 0) {
                    loadImage(change.target, function () {
                        observer.unobserve(change.target);
                    });
                }
            });
        });
        imgs.forEach(function (img) {
            observer.observe(img);
        });
    } else {
        var onscroll = throttle(function () {
            imgs = imgs.filter(function (img) {
                return img.classList.contains('lazyload');
            });
            imgs.forEach(function (img) {
                return isVisible(img) && loadImage(img);
            });
            //如果图片到没有了，移除监听事件提高性能
            if (imgs.length === 0) {
                window.removeEventListener('scroll', onscroll);
            }
            imgs.forEach(function (img) {
                return isVisible(img) && loadImage(img);
            });
        }, 300);
        window.addEventListener('scroll', onscroll);
        window.dispatchEvent(new Event('scroll'));
    }
}

/**
 * @description 节流
 * @param {any} func 函数
 * @param {any} wait 时间
 * @returns 
 */
function throttle(func, wait) {
    var context = void 0,
        args = void 0,
        timer = void 0;
    var prev = 0;
    return function fn() {
        var now = +new Date();
        var diff = now - prev;
        context = this;
        args = arguments;
        if (!prev || diff >= wait) {
            func.apply(context, args);
            prev = now;
        } else if (diff < wait) {
            clearTimeout(timer);
            timer = setTimeout(fn, wait - diff);
        }
    };
}
/**
 * @description 判断元素是否可见
 * @param {any} img 
 * @returns 
 */
function isVisible(img) {
    var _img$getBoundingClien = img.getBoundingClientRect(),
        top = _img$getBoundingClien.top,
        left = _img$getBoundingClien.left,
        right = _img$getBoundingClien.right,
        bottom = _img$getBoundingClien.bottom;

    var windowWidth = document.documentElement.clientWidth;
    var windowHeight = document.documentElement.clientHeight;
    return (top > 0 && top < windowHeight || bottom > 0 && bottom < windowHeight) && (left > 0 && left < windowWidth || right > 0 && right < windowWidth);
}

/**
 * @description 加载图片
 * @param {any} img 
 * @param {any} callback 
 */
function loadImage(img, callback) {
    var image = new Image();
    image.src = img.dataset.src;
    image.onload = function () {
        img.src = image.src;
        img.classList.remove('lazyload');
        if (Object.prototype.toString.call(callback) === '[object Function]') {
            callback();
        }
    };
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.songUrl = songUrl;
exports.lyricsUrl = lyricsUrl;
exports.albumCoverUrl = albumCoverUrl;
exports.searchUrl = searchUrl;

var _content = __webpack_require__(0);

//歌 url
function songUrl(id) {
    // return `http://ws.stream.qqmusic.qq.com/${id}.m4a?fromtag=46`;
    return 'http://isure.stream.qqmusic.qq.com/C100' + id + '.m4a?fromtag=32';
}

//歌词 url
function lyricsUrl(songid) {
    return _content.LYRICS_URL + '?id=' + songid;
}

//相册
function albumCoverUrl(id) {
    return 'https://y.gtimg.cn/music/photo_new/T002R150x150M000' + id + '.jpg';
}

//处理搜索的 url 
// @param {any} keyword 用户输入的数据
// @param {number} [page=1]  页数默认为1
function searchUrl(keyword) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return _content.SEARCH_URL + '?keyword=' + keyword + '&page=' + page;
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _recommend = __webpack_require__(4);

var _tab = __webpack_require__(6);

var _tab2 = _interopRequireDefault(_tab);

var _toplist = __webpack_require__(7);

var _search = __webpack_require__(8);

var _player = __webpack_require__(9);

var _hotkey = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var recommend = new _recommend.Recommend(document.querySelector('.rec-view')).start();

var hotkey = new _hotkey.HotKey(document.querySelector('.result-tags')).start();

var search = new _search.Search().search();

var toplist = new _toplist.TopList(document.querySelector('.rec-view')).start();

var player = new _player.MusicPlayer(document.querySelector('#player'));

document.querySelector('#show_player').addEventListener('click', function () {
    player.show();
});

onHashChange();

addEventListener('hashchange', onHashChange);

function onHashChange() {
    var hash = location.hash;
    if (/#player\?.+/.test(hash)) {
        var matches = hash.slice(hash.indexOf('?') + 1).match(/(\w+)=([^&]+)/g);
        var options = matches && matches.reduce(function (res, cur) {
            var arr = cur.split('=');
            res[arr[0]] = decodeURIComponent(arr[1]);
            return res;
        }, {});
        // console.log(options);
        player.play(options);
    } else {
        player.hide();
    }
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Recommend = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _content = __webpack_require__(0);

var _slider = __webpack_require__(5);

var _lazyload = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Recommend = exports.Recommend = function () {
    function Recommend(el) {
        _classCallCheck(this, Recommend);

        this.el = el;
    }
    /**
     * @description 开始
     * @memberof Recommend
     */


    _createClass(Recommend, [{
        key: 'start',
        value: function start() {
            var _this2 = this;

            if ('fetch' in window) {
                fetch(_content.RECOMMEND_URL).then(function (res) {
                    return res.json();
                }).then(function (json) {
                    return _this2.json = json;
                }).then(function () {
                    return _this2.render();
                });
            } else {
                //如果不兼容 fetch
                var xhr = void 0;
                var _this = this;
                if (window.XMLHttpRequest) {
                    xhr = new XMLHttpRequest();
                } else {
                    //兼容 ie6
                    xhr = new ActiveXObject('Microsoft.XMLHTTP');
                }
                //连接
                xhr.open('GET', _content.RECOMMEND_URL, true);
                //发送请求
                xhr.send();

                xhr.onreadystatechange = function () {
                    //读取完成
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            _this.json = JSON.parse(xhr.responseText);
                            _this.render();
                        } else {
                            console.log('失败' + xhr.status);
                        }
                    }
                };
            }
        }
        /**
         * @description 渲染数据
         * @memberof Recommend
         */

    }, {
        key: 'render',
        value: function render() {
            document.querySelector('.loading').classList.add('hide');
            this.renderSlider(this.json.data.slider);
            this.renderRadios(this.json.data.radioList);
            this.renderPlayList(this.json.data.songList);
            (0, _lazyload.lazyload)();
        }
        /**
         * @description 渲染轮播图
         * @param {any} slides 
         * @memberof Recommend
         */

    }, {
        key: 'renderSlider',
        value: function renderSlider(slides) {
            this.slider = new _slider.Slider({
                el: this.el.querySelector('#slider'),
                slides: slides.map(function (slide) {
                    return {
                        link: slide.linkUrl,
                        image: slide.picUrl
                    };
                })
            });
        }

        /**
         * @description 渲染电台部分
         * @param {any} radios 
         * @memberof Recommend
         */

    }, {
        key: 'renderRadios',
        value: function renderRadios(radios) {
            document.querySelector('.radios .list').innerHTML = radios.map(function (radio) {
                return '<div class="list-item">\n                <div class="list-media">\n                    <img data-src="' + radio.picUrl + '" class="lazyload" src="./images/default_pic.jpg">\n                    <span class="icon icon_play"></span>\n                </div>\n                <div class="list-info">' + radio.Ftitle + '</div>\n            </div>';
            }).join('');
        }

        /**
         * @description 渲染推荐页的热门歌单
         * @param {any} playlists 
         * @memberof Recommend
         */

    }, {
        key: 'renderPlayList',
        value: function renderPlayList(playlists) {
            document.querySelector('.playlists .list').innerHTML = playlists.map(function (list) {
                return '<div class="list-item">\n            <a href=\'https://y.qq.com/w/taoge.html?ADTAG=myqq&from=myqq&channel=10007100&id=' + list.id + '\'>\n            <div class="list-media">\n                <img class="lazyload" data-src="' + list.picUrl + '" src="./images/default_pic.jpg">\n                <span class="listen_count"><span class="icon icon_listen"></span>' + ((list.accessnum / 10000).toFixed(1) + '万') + '</span>\n                <span class="icon icon_play"></span>\n            </div>\n            <div class="list-info">\n                <div class="list_tit">' + list.songListDesc + '</div>\n                <div class="list-text"></div>\n            </div>\n            </a>\n        </div>';
            }).join('');
        }
    }]);

    return Recommend;
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Slider = exports.Slider = function () {
    function Slider() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Slider);

        this.el = options.el;
        this.slides = options.slides;
        this.interval = options.interval || 2000;
        this.index = 0;
        this.width = 0; //每张图片的大小的宽度
        this.touchX = 0; //触控开始的手指最初落点
        this.ready_moved = true; //判断每次滑动开始的标记变量
        this.render();
        this.bindEvent();
        this.start();
        this.onresize();
    }
    /**
     * @description 当窗口发生变化的时候，获取屏幕宽度，使图片发生改变
     * @memberof Slider
     */


    _createClass(Slider, [{
        key: 'onresize',
        value: function onresize() {
            var _this = this;
            window.addEventListener('resize', function () {
                _this.width = _this.el.clientWidth;
            });
        }
        /**
         * @description 渲染
         * @memberof Slider
         */

    }, {
        key: 'render',
        value: function render() {
            this.el.innerHTML = '<div class="qq-slider-wrap"></div>\n        <p class="ui-slider-dots">\n        <b class="active"></b>\n        <b class=""></b>\n        <b class=""></b>\n        <b class=""></b>\n        <b class=""></b>\n        </p>';
            this.dots = document.querySelector('.ui-slider-dots');
            this.wrap = this.el.firstElementChild;
            this.wrap.style.width = (this.slides.length + 1) * 100 + '%';
            this.wrap.innerHTML = this.slides.map(function (slide) {
                return '<div class="qq-slider-item">\n          <a href="' + slide.link + '">\n            <img src="' + slide.image + '">\n          </a>\n      </div>';
            }).join('');
            this.width = this.el.clientWidth;
            var first = this.wrap.firstElementChild;
            this.wrap.insertAdjacentHTML('beforeend', this.domToString(first)); //无缝滚动拷贝第一个到到容器的最后一个
        }

        /**
         * @description dom 元素转为字符串
         * @param {any} node 
         * @returns string
         * @memberof Slider
         */

    }, {
        key: 'domToString',
        value: function domToString(node) {
            var tmpNode = document.createElement('div');
            tmpNode.appendChild(node.cloneNode(true));
            var str = tmpNode.innerHTML;
            tmpNode = node = null; // 解除引用，以便于垃圾回收  
            return str;
        }

        /**
         * @description 自动播放
         * @memberof Slider
         */

    }, {
        key: 'autoPlay',
        value: function autoPlay() {
            this.timer = setInterval(this.next.bind(this), this.interval);
        }

        /**
         * @description 开始播放
         * @memberof Slider
         */

    }, {
        key: 'start',
        value: function start() {
            this.autoPlay();
        }

        /**
         * @description 下一张
         * @returns 
         * @memberof Slider
         */

    }, {
        key: 'next',
        value: function next() {
            //先判断在加
            if (this.index === this.slides.length) {
                //5
                this.index = 0;
                this.wrap.style.left = '0';
            }
            this.index += 1;
            this.animate(this.wrap, -this.width * this.index);
            this.setActiveDot();
        }

        /**
         * @description 动画
         * @param {any} obj 
         * @param {any} target 
         * @memberof Slider
         */

    }, {
        key: 'animate',
        value: function animate(obj, target) {
            clearInterval(obj.timer);
            obj.timer = setInterval(function () {
                var leader = obj.offsetLeft;
                var step = (target - leader) / 2;
                step = step > 0 ? Math.ceil(step) : Math.floor(step);
                leader = leader + step;
                obj.style.left = leader + 'px';
                if (leader === target) {
                    clearInterval(obj.timer);
                }
            }, 30);
        }

        /**
         * @description 上一张
         * @returns 
         * @memberof Slider
         */

    }, {
        key: 'pre',
        value: function pre() {
            if (this.index === 0) {
                this.index = this.slides.length;
                this.wrap.style.left = '-' + this.index * this.width + 'px';
            }
            this.index -= 1;
            this.animate(this.wrap, -this.index * this.width);
            this.setActiveDot();
        }

        /**
         * @description 设置激活的小点
         * @memberof Slider
         */

    }, {
        key: 'setActiveDot',
        value: function setActiveDot() {
            var len = this.dots.children.length;
            for (var i = 0; i <= len; i++) {
                var b = document.getElementsByTagName('b')[i];
                if (b) b.classList.remove('active'); //判断 b 是否存在
                if (this.index === i) {
                    if (b) b.classList.add('active');
                }
                if (this.index === 5) {
                    //如果 index 等于5 那么将圆点变为第一个
                    b = document.getElementsByTagName('b')[0];
                    b.classList.add('active');
                }
            }
        }

        /**
         * @description 绑定事件
         * @memberof Slider
         */

    }, {
        key: 'bindEvent',
        value: function bindEvent() {
            this.wrap.addEventListener('touchstart', this.touchstart.bind(this));
            this.wrap.addEventListener('touchmove', this.touchmove.bind(this));
            this.wrap.addEventListener('touchend', this.touchend.bind(this));
        }
        /**
         * @description touchstart事件
         * @param {any} e 
         * @memberof Slider
         */

    }, {
        key: 'touchstart',
        value: function touchstart(e) {
            clearInterval(this.timer);
            if (this.ready_moved) {
                var touch = e.targetTouches[0];
                this.touchX = touch.clientX;
                this.ready_moved = false;
            }
        }
        /**
         * @description touchmove 事件
         * @param {any} e 
         * @memberof Slider
         */

    }, {
        key: 'touchmove',
        value: function touchmove(e) {
            e.preventDefault();
            e.stopPropagation();
            clearInterval(this.timer);
            if (!this.ready_moved) {
                var move = e.changedTouches[0];
                var moveAt = move.clientX;
                var diff = moveAt - this.touchX;
                var offset = -this.index * this.width; //一张图片的偏移量
                if (diff > 0 && diff <= this.width && offset + diff < 0) {
                    //向右移，并且 diff 要小于一张图片的宽度
                    this.animate(this.wrap, offset + diff);
                } else if (diff < 0 && Math.abs(diff) <= this.width && offset - Math.abs(diff) > -this.slides.length * this.width) {
                    //向左移,并且 diff 要小于一张图片的宽度
                    this.animate(this.wrap, offset - Math.abs(diff));
                } else if (offset + diff > 0) {
                    //当临界值在第一张向左移的时候
                    if (this.index === 0) {
                        this.index = this.slides.length;
                        this.wrap.style.left = '-' + this.index * this.width + 'px';
                    }
                    this.animate(this.wrap, -(this.index * this.width) + diff);
                } else if (offset - diff < this.width * this.slides.length) {
                    //当最后一张向右移的时候
                    if (this.index === this.slides.length) {
                        this.index = 0;
                        this.wrap.style.left = '-' + this.index * this.width + 'px';
                    }
                    this.animate(this.wrap, -(this.index * this.width) - diff);
                }
            }
        }
        /**
         * @description touchend事件
         * @param {any} e 
         * @memberof Slider
         */

    }, {
        key: 'touchend',
        value: function touchend(e) {
            var _this = this;
            if (!_this.ready_moved) {
                clearInterval(_this.timer);
                var release = e.changedTouches[0];
                var releasedAt = release.clientX;
                var diff = releasedAt - _this.touchX;
                if (diff > _this.width / 2) {
                    //当右移滑动距离大于图片宽度的一半时
                    _this.pre();
                    _this.autoPlay();
                    _this.ready_moved = true;
                } else if (diff < -(_this.width / 2)) {
                    //当左移滑动距离小于宽度的一半时（-400px < -360px）
                    _this.next();
                    _this.autoPlay();
                    _this.ready_moved = true;
                } else {
                    //回到原来的图片
                    _this.animate(_this.wrap, -_this.index * _this.width);
                    _this.autoPlay();
                    _this.ready_moved = true;
                }
            }
        }
    }]);

    return Slider;
}();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


document.addEventListener('touchstart', function (event) {
    var target = event.target;
    if (target.dataset.role !== 'tab') return;
    [].forEach.call(target.parentElement.children, function (tab) {
        tab.classList.remove('active');
    });
    target.classList.add('active');
    var content = document.querySelector(target.dataset.view);
    if (content) {
        [].forEach.call(content.parentElement.children, function (child) {
            child.style.display = 'none';
        });
        content.style.display = 'block';
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TopList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _content = __webpack_require__(0);

var _lazyload = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TopList = exports.TopList = function () {
    function TopList(el) {
        _classCallCheck(this, TopList);

        this.el = el;
    }
    /**
     * @description 开始
     * @memberof TopList
     */


    _createClass(TopList, [{
        key: 'start',
        value: function start() {
            var _this2 = this;

            if ('fetch' in window) {
                fetch(_content.TOPLIST_URL).then(function (res) {
                    return res.json();
                }).then(function (json) {
                    return _this2.list = json.data.topList;
                }).then(function () {
                    return _this2.render();
                });
            } else {
                var xhr = void 0;
                var _this = this;
                if (window.XMLHttpRequest) {
                    xhr = new XMLHttpRequest();
                } else {
                    xhr = new ActiveXObject('Microsoft.XMLHTTP');
                }
                xhr.open('GET', _content.TOPLIST_URL, true);
                xhr.send();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            _this.json = JSON.parse(xhr.responseText);
                            _this.render();
                        } else {
                            console.log('失败' + xhr.status);
                        }
                    }
                };
            }
        }

        /**
         * @description 渲染
         * @memberof TopList
         */

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            document.querySelector('.toplist').innerHTML = this.list.map(function (item) {
                return '<li class="top-item">\n        <div class="top-item-media">\n          <a href=\'https://y.qq.com/w/toplist.html?ADTAG=myqq&from=myqq&channel=10007100&id=' + item.id + '&type=top\'>\n            <img class="lazyload" data-src="' + item.picUrl.replace('http://', 'https://') + '" src="./images/default_pic.jpg">\n            <span class="listen_count"><i class="icon icon-listen"></i>' + ((item.listenCount / 10000).toFixed(1) + '万') + '</span>\n          </a>\n        </div>\n        <a href=\'https://y.qq.com/w/toplist.html?ADTAG=myqq&from=myqq&channel=10007100&id=' + item.id + '&type=top\'>\n            <div class="top-item-info">\n            <h3 class="top-item-title ellipsis">' + item.topTitle + '</h3>\n            <ul class="top-item-list">' + _this3.songlist(item.songList) + '</ul>\n            </div>\n        </a>\n      </li>';
            }).join('');
            (0, _lazyload.lazyload)(this.el.querySelectorAll('.lazyload'));
        }

        /**
         * @description 获取歌
         * @param {any} songs 返回字符串
         * @returns 
         * @memberof TopList
         */

    }, {
        key: 'songlist',
        value: function songlist(songs) {
            return songs.map(function (song, i) {
                return '<li class="top-item-song">\n        <i class="song-index">' + (i + 1) + '</i>\n        <span class="song-name">' + song.songname + '</span>- ' + song.singername + '\n      </li>';
            }).join('');
        }
    }]);

    return TopList;
}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Search = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _helper = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Search = exports.Search = function () {
    function Search() {
        _classCallCheck(this, Search);

        this.input = document.querySelector('#search');
        this.songs = document.querySelector('.song-list');
        this.songsObject = {}; //存放歌曲
        this.keyword = ''; //输入搜索的值
        this.page = 1; //默认页数为1
        this.isLoad = true; //能否继续加载数据
        this.fetching = false; //正在 fetch
        this.history = [];
        this.delete = document.querySelector('.icon-delete'); //删除
        this.cancel = document.querySelector('.search-cancel'); //取消
        this.hotKeys = document.querySelector('#hot-keys'); //热门歌曲
        this.recordKeys = document.querySelector('.record-keys'); //搜索记录
        this.input.addEventListener('keyup', this.onEnter.bind(this));

        window.addEventListener('scroll', this.onScroll.bind(this));
        window.addEventListener('click', this.onClick.bind(this));

        this.HISTORY_KEY = 'search_history';
        this.history = localStorage.getItem(this.HISTORY_KEY) ? localStorage.getItem(this.HISTORY_KEY).split(',') : [];
    }

    /**
     * @description enter 事件
     * @param {any} event 
     * @returns 
     * @memberof Search
     */


    _createClass(Search, [{
        key: 'onEnter',
        value: function onEnter(event) {
            //获取输入的值,并且去除两边的空格
            var keyword = event.target.value.trim();
            if (keyword) {
                this.delete.classList.remove('hide');
            } else {
                this.delete.classList.add('hide');
                return this.reset();
            }
            //如果不是 enter 直接返回
            if (event.keyCode !== 13) return;
            this.recordKeys.classList.add('hide');
            this.addHistory(keyword);
            this.search(keyword);
        }

        /**
         * @description 点击事件
         * @param {any} e 
         * @memberof Search
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            // console.log(e.target);
            //如果点击到了输入按钮
            if (e.target === this.input) {
                this.cancel.classList.remove('hide');
                this.hotKeys.classList.add('hide');
                this.recordKeys.classList.remove('hide');
                this.renderHistory();
                this.reset();
            }
            //如果点击到了取消按钮
            if (e.target === this.cancel) {
                this.cancel.classList.add('hide');
                this.delete.classList.add('hide');
                this.hotKeys.classList.remove('hide');
                this.recordKeys.classList.add('hide');
                this.input.value = '';
                this.reset();
            }
            //如果点击到了删除按钮
            if (e.target === this.delete) {
                this.input.value = '';
                this.delete.classList.add('hide');
                this.reset();
            }
            //如果匹配到了清除搜索记录
            if (e.target.matches('.record-delete')) {
                this.history = [];
                localStorage.setItem(this.HISTORY_KEY, this.history);
                this.recordKeys.innerHTML = '';
            }
            //如果匹配到了单条记录的删除按钮
            if (e.target.matches('.icon-close')) {
                var index = this.history.indexOf(e.target.previousElementSibling.innerHTML);
                this.history.splice(index, 1);
                localStorage.setItem(this.HISTORY_KEY, this.history);
                this.renderHistory();
            }
            //如果点到了热门搜索的关键词或者点到了搜索记录的歌
            if (e.target.matches('.tag-keyword') || e.target.matches('.record-con')) {
                // console.log(e.target.innerHTML)
                this.input.value = e.target.innerHTML;
                this.keyword = e.target.innerHTML;
                this.delete.classList.remove('hide');
                this.cancel.classList.remove('hide');
                this.hotKeys.classList.add('hide');
                this.addHistory(this.keyword);
                this.search(this.keyword);
            }
        }

        /**
         * @description 添加历史
         * @param {any} keyword 
         * @memberof Search
         */

    }, {
        key: 'addHistory',
        value: function addHistory(keyword) {
            // console.log('keyword： ' + keyword);
            var index = this.history.indexOf(keyword);
            if (index === -1) {
                this.history.unshift(keyword);
                localStorage.setItem(this.HISTORY_KEY, this.history);
            }
        }

        /**
         * @description 渲染历史
         * @memberof Search
         */

    }, {
        key: 'renderHistory',
        value: function renderHistory() {
            if (this.history.length > 0) {
                var historyHTML = this.history.map(function (item) {
                    return '\n                <li>\n                    <a href="#" class="record-main">\n                        <span class="icon icon-clock"></span>\n                        <span class="record-con ellipsis">' + item + '</span>\n                        <span class="icon icon-close"></span>\n                    </a>\n                </li>\n            ';
                }).join('');
                historyHTML += '\n                <p class="record-delete">\u6E05\u9664\u641C\u7D22\u8BB0\u5F55</p>\n            ';
                // console.log(historyHTML)
                // console.log(this.recordKeys)
                this.recordKeys.innerHTML = historyHTML;
            } else if (this.history.length === 0) {
                this.recordKeys.innerHTML = '';
                this.history = [];
            }
        }

        /**
         * @description 重置
         * @memberof Search
         */

    }, {
        key: 'reset',
        value: function reset() {
            this.page = 1;
            this.keyword = '';
            this.isLoad = true;
            this.songsObject = {};
            this.songs.innerHTML = '';
            document.querySelector('.loading-icon').style.display = 'block';
            document.querySelector('.loading-text').style.display = 'block';
            document.querySelector('.loading-done').style.display = 'none';
            document.querySelector('.search-loading').classList.remove('show');
        }

        /**
         * @description 滚动事件
         * @param {any} e 
         * @returns 
         * @memberof Search
         */

    }, {
        key: 'onScroll',
        value: function onScroll(e) {
            if (this.isLoad) {
                if (document.documentElement.clientHeight + pageYOffset > document.body.scrollHeight - 100) {
                    this.search(this.keyword, this.page + 1);
                }
            } else {
                return window.removeEventListener('scroll', this.onScroll.bind(this));
            }
        }

        /**
         * @description 搜索
         * @param {any} keyword 用户输入的数据
         * @param {any} page 页数
         * @memberof Search
         */

    }, {
        key: 'search',
        value: function search(keyword, page) {
            var _this = this;

            //刚进来时 keyword为 undefined ，因为没有 enter
            if (keyword === undefined) keyword = '';
            if (keyword === '') return;
            //如果已经搜索过，并且没有改动 keyword 那么直接返回
            if (this.keyword === keyword && this.songsObject[page || this.page]) return;
            if (this.keyword !== keyword) this.reset();
            if (this.fetching || !this.isLoad) return;
            this.keyword = keyword;
            this.loading();
            fetch((0, _helper.searchUrl)(this.keyword, page || this.page)).then(function (res) {
                return res.json();
            }).then(function (json) {
                _this.page = json.data.song.curpage;
                _this.songsObject[_this.page] = json.data.song.list;
                _this.isLoad = json.message !== 'no results';
                return json.data.song.list;
            }).then(function (songs) {
                return _this.append(songs);
            }).then(function () {
                return _this.accomplish();
            }).catch(function () {
                return console.log('error');
            });
        }

        /**
         * @description 添加歌曲的html到页面
         * @param {any} songs 
         * @memberof Search
         */

    }, {
        key: 'append',
        value: function append(songs) {
            var html = songs.map(function (song) {
                var artist = song.singer.map(function (s) {
                    return s.name;
                }).join('');
                return '<a class="song-item"\n               href="#player?artist=' + artist + '&songmid=' + song.songmid + '&songid=' + song.songid + '&songname=' + song.songname + '&albummid=' + song.albummid + '&duration=' + song.interval + '">\n              <i class="icon icon-music"></i>\n              <div class="song-name">' + song.songname + '</div>\n              <div class="song-artist">' + artist + '</div>\n            </a>';
            }).join('');
            this.songs.insertAdjacentHTML('beforeend', html);
        }

        /**
        * @description 函数加载
        * @memberof Search
        */

    }, {
        key: 'loading',
        value: function loading() {
            this.fetching = true;
            document.querySelector('.search-loading').classList.add('show');
        }

        /**
         * @description 函数加载完成
         * @memberof Search
         */

    }, {
        key: 'accomplish',
        value: function accomplish() {
            this.fetching = false;
            if (!this.isLoad) {
                //如果不能加载了，就显示已加载全部
                document.querySelector('.loading-icon').style.display = 'none';
                document.querySelector('.loading-text').style.display = 'none';
                document.querySelector('.loading-done').style.display = 'block';
            } else {
                document.querySelector('.search-loading').classList.remove('show');
            }
        }
    }]);

    return Search;
}();

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MusicPlayer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _helper = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @description 音乐播放器界面
 * @export
 * @class MusicPlayer
 */
var MusicPlayer = exports.MusicPlayer = function () {
    function MusicPlayer(el) {
        _classCallCheck(this, MusicPlayer);

        this.el = el;
        this.el.addEventListener('click', this.handleEvent.bind(this));
        this.audio = this.createAudio();
        this.lyrics = new LyricsPlayer(this.el.querySelector('.player-lyrics'), this.audio);
        this.progress = new Progress(this.el.querySelector('.progress'));
        this.fetching = false;
    }
    /**
     * @description 创建 audio
     * @returns HTMLAudioElement
     * @memberof MusicPlayer
     */


    _createClass(MusicPlayer, [{
        key: 'createAudio',
        value: function createAudio() {
            var _this2 = this;

            var audio = document.createElement('audio');
            audio.id = 'player-' + Math.floor(Math.random() * 100) + '-' + +new Date();
            // console.log(audio.id)
            //播放结束的时候
            audio.addEventListener('ended', function () {
                _this2.audio.play();
                _this2.lyrics.restart();
                _this2.progress.restart();
            });
            document.body.appendChild(audio);
            return audio;
        }
        /**
         * @description 处理事件
         * @param {any} event 
         * @memberof MusicPlayer
         */

    }, {
        key: 'handleEvent',
        value: function handleEvent(event) {
            var target = event.target;
            // console.log(target);
            switch (true) {
                case target.matches('.icon-play'):
                    this.onPlay(event);
                    break;
                case target.matches('.icon-pause'):
                    this.onPause(event);
                    break;
                case target.matches('.icon-list'):
                    this.hide();
                    break;
            }
        }
        /**
         * @description 显示 play 按钮
         * @param {any} event 
         * @memberof MusicPlayer
         */

    }, {
        key: 'onPlay',
        value: function onPlay(event) {
            //如果正在 fetching 返回
            if (this.fetching) return;
            this.audio.play();
            this.lyrics.start();
            this.progress.start();
            event.target.classList.remove('icon-play');
            event.target.classList.add('icon-pause');
        }

        /**
         * @description 播放
         * @param {any} [options={}] 
         * @returns 
         * @memberof MusicPlayer
         */

    }, {
        key: 'play',
        value: function play() {
            var _this3 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!options) return 0;
            this.el.querySelector('.song-name').innerText = options.songname;
            this.el.querySelector('.song-artist').innerText = options.artist;
            this.progress.reset(options.duration);

            //设置背景图和头像
            var coverUrl = (0, _helper.albumCoverUrl)(options.albummid);
            this.el.querySelector('.album-cover').src = coverUrl;
            this.el.querySelector('.player-background').style.backgroundImage = 'url(' + coverUrl + ')';

            if (options.songid) {
                if (this.songid !== options.songid) {
                    this.el.querySelector('.icon-action').className = 'icon-action icon-play';
                }

                this.songmid = options.songmid;
                console.log(this.songmid);
                this.songid = options.songid;
                this.audio.src = (0, _helper.songUrl)(this.songmid);
                this.fetching = true;
                fetch((0, _helper.lyricsUrl)(this.songid)).then(function (res) {
                    return res.json();
                }).then(function (json) {
                    return json.lyric;
                }).then(function (text) {
                    return _this3.lyrics.reset(text);
                }).catch(function (err) {
                    return alert(err);
                }).then(function () {
                    _this3.fetching = false;
                });
            }
            this.show();
        }
        /**
         * @description 显示暂停按钮
         * @param {any} event 
         * @memberof MusicPlayer
         */

    }, {
        key: 'onPause',
        value: function onPause(event) {
            this.audio.pause();
            this.lyrics.pause();
            this.progress.pause();
            event.target.classList.remove('icon-pause');
            event.target.classList.add('icon-play');
        }
        /**
         * @description 显示播放器
         * @memberof MusicPlayer
         */

    }, {
        key: 'show',
        value: function show() {
            this.el.classList.add('show');
            document.body.classList.add('noscroll');
        }
        /**
         * @description 隐藏播放器
         * @memberof MusicPlayer
         */

    }, {
        key: 'hide',
        value: function hide() {
            this.el.classList.remove('show');
            document.body.classList.remove('noscroll');
        }
    }]);

    return MusicPlayer;
}();

/**
 * @description 进度条
 * @export
 * @class Progress
 */


var Progress = function () {
    function Progress(el, duration, start) {
        _classCallCheck(this, Progress);

        this.$el = el;
        this.elapsed = 0; //当前时间
        this.duration = duration || 0; //持续时间
        this.progress = 0; //进度条
        this.render();
        this.$progress = this.$el.querySelector('.progress-bar-progress');
        this.$elapsed = this.$el.querySelector('.progress-elapsed');
        this.$duration = this.$el.querySelector('.progress-duration');
        this.$elapsed.innerText = this.formatTime(this.elapsed);
        this.$duration.innerText = this.formatTime(this.duration);
        if (start) this.start();
    }
    /**
     * @description 重新开始
     * @memberof Progress
     */


    _createClass(Progress, [{
        key: 'restart',
        value: function restart() {
            this.reset();
            this.start();
        }
        /**
         * @description 开始
         * @memberof Progress
         */

    }, {
        key: 'start',
        value: function start() {
            this.pause();
            this.intervalId = setInterval(this.update.bind(this), 50);
        }
        /**
         * @description 更新时间
         * @memberof Progress
         */

    }, {
        key: 'update',
        value: function update() {
            this.elapsed += 0.05;
            //如果当前时间大于总的持续时间的话就时间重置
            if (this.elapsed >= this.duration) this.reset();
            this.progress = this.elapsed / this.duration;
            this.$progress.style.transform = 'translate(' + (this.progress * 100 - 100) + '%)';
            this.$elapsed.innerText = this.formatTime(this.elapsed);
        }
        /**
         * @description 清除计时器
         * @memberof Progress
         */

    }, {
        key: 'pause',
        value: function pause() {
            clearInterval(this.intervalId);
        }
        /**
         * @description 重置
         * @param {any} duration 
         * @memberof Progress
         */

    }, {
        key: 'reset',
        value: function reset(duration) {
            this.pause();
            this.elapsed = 0;
            this.progress = 0;
            this.$progress.style.transform = 'translate(-100%)';
            this.$elapsed.innerText = this.formatTime(this.elapsed);
            if (duration) {
                this.duration = +duration;
                this.$duration.innerText = this.formatTime(this.duration);
            }
        }
        /**
         * @description 渲染
         * @memberof Progress
         */

    }, {
        key: 'render',
        value: function render() {
            this.$el.innerHTML = '\n          <div class="progress-time progress-elapsed"></div>\n            <div class="progress-bar">\n              <div class="progress-bar-progress"></div>\n            </div>\n          <div class="progress-time progress-duration"></div>\n        ';
        }
        /**
         * @description 格式化时间毫秒
         * @param {any} seconds 
         * @returns 返回 05:10这种形式的时间
         * @memberof Progress
         */

    }, {
        key: 'formatTime',
        value: function formatTime(seconds) {
            var mins = Math.floor(seconds / 60);
            var secs = Math.floor(seconds % 60);
            if (mins < 10) mins = '0' + mins;
            if (secs < 10) secs = '0' + secs;
            return mins + ':' + secs;
        }
    }]);

    return Progress;
}();

/**
 * @description 歌词
 * @export
 * @class LyricsPlayer
 */


var LyricsPlayer = function () {
    function LyricsPlayer(el, audio) {
        _classCallCheck(this, LyricsPlayer);

        this.$el = el;
        this.$el.innerHTML = '<div class="player-lyrics-lines"></div>';
        this.$lines = this.$el.querySelector('.player-lyrics-lines');
        this.$audio = audio;
        this.text = ''; //歌词文本
        this.index = 0; //页数
        this.lyrics = []; //歌词数组
        this.reset(this.text);
    }

    _createClass(LyricsPlayer, [{
        key: 'start',
        value: function start() {
            this.pause();
            this.intervalId = setInterval(this.update.bind(this), 1000);
        }
        /**
         * @description 重新开始
         * @memberof LyricsPlayer
         */

    }, {
        key: 'restart',
        value: function restart() {
            this.reset();
            this.start();
        }
    }, {
        key: 'pause',
        value: function pause() {
            clearInterval(this.intervalId);
        }
        /**
         * @description 更新歌词
         * @memberof LyricsPlayer
         */

    }, {
        key: 'update',
        value: function update() {
            var _this = this;
            this.$audio.ontimeupdate = function (e) {
                for (var i = 0, l = _this.lyrics.length; i < l; i++) {
                    // console.log(this.currentTime,_this.getSeconds(_this.lyrics[i]));
                    if (this.currentTime /*当前播放的时间*/ > _this.getSeconds(_this.lyrics[i]) - 0.50) {
                        //显示到页面
                        _this.$lines.children[_this.index].classList.remove('active');
                        _this.$lines.children[i].classList.add('active');
                        _this.index = i;
                    }
                }
            };
            //如果歌词页数大于2的话，歌词向上翻
            if (this.index > 2) {
                var y = -(this.index - 2) * this.LINE_HEIGHT;
                this.$lines.style.transform = 'translateY(' + y + 'px)';
            }
        }
        /**
         * @description 重置
         * @param {any} text 
         * @memberof LyricsPlayer
         */

    }, {
        key: 'reset',
        value: function reset(text) {
            this.pause();
            this.index = 0;
            this.$lines.style.transform = 'translateY(0)';
            var $active = this.$lines.querySelector('.active');
            if ($active) {
                $active.classList.remove('active');
            }
            if (text) {
                this.text = this.formatText(text) || '';
                this.lyrics = this.text.match(/^\[\d{2}:\d{2}.\d{2}\](.+)$/gm) || [];
                //如果 lyrics 数组有长度
                if (this.lyrics.length) this.render();
            }

            if (this.lyrics.length) {
                this.$lines.children[this.index].classList.add('active');
            }
        }
        //获取秒数

    }, {
        key: 'getSeconds',
        value: function getSeconds(line) {
            return +line.replace(/^\[(\d{2}):(\d{2}\.\d{2}).*/, function (match, p1, p2) {
                return +p1 * 60 + parseFloat(+p2);
            });
        }
        /**
         * @description 渲染
         * @memberof LyricsPlayer
         */

    }, {
        key: 'render',
        value: function render() {
            var html = this.lyrics.map(function (line) {
                return '\n          <div class="player-lyrics-line">' + line.slice(10) + '</div>\n        ';
            }).join('');
            this.$lines.innerHTML = html;
        }
        /**
         * @description 格式化文本 类似⬇️
         * [xx:xx.xx]xxxxx
         * [xx:xx.xx]xxxxx
         * [xx:xx.xx]xxxxx
         * @param {any} text 
         * @returns 
         * @memberof LyricsPlayer
         */

    }, {
        key: 'formatText',
        value: function formatText(text) {
            var div = document.createElement('div');
            div.innerHTML = text;
            return div.innerText;
        }
    }]);

    return LyricsPlayer;
}();

LyricsPlayer.prototype.LINE_HEIGHT = 42;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HotKey = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _content = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HotKey = exports.HotKey = function () {
    function HotKey(el) {
        _classCallCheck(this, HotKey);

        this.el = el;
    }

    _createClass(HotKey, [{
        key: 'start',
        value: function start() {
            var _this = this;

            fetch(_content.HOTKEYS_URL).then(function (res) {
                return res.json();
            }).then(function (json) {
                return _this.render(json.data);
            });
        }
        /**
         * @description 渲染数据
         * @param {any} data
         * @memberof HotKey
         */

    }, {
        key: 'render',
        value: function render(data) {
            var keys = data.hotkey;
            var hotKeys = this.shuffle(keys, 6).map(function (hotkey) {
                return '\n            <a href="#" class="tag tag-keyword">' + hotkey.k + '</a>\n        ';
            });
            // console.log(hotkeys);
            this.el.innerHTML = '<a href="' + data.special_url + '" class="tag tag-hot">' + data.special_key + '</a>' + hotKeys;
        }
        /**
         * @description 洗牌
         * @param {any} array
         * @param {any} count
         * @returns array
         * @memberof HotKey
         */

    }, {
        key: 'shuffle',
        value: function shuffle(array, count) {
            var arr = [];
            var len = Math.min(count, array.length);
            for (var i = 0; i < len; i++) {
                var temp = array;
                var random = Math.floor(Math.random() * temp.length);
                arr[i] = temp[random];
                array.splice(random, 1);
            }
            return arr;
        }
    }]);

    return HotKey;
}();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/app.js